module.exports = __webpack_public_path__ + "static/A02-d56a4b68bd7fb07fcb2ddce36e0a91aa.jpg";